// extracted by mini-css-extract-plugin
export var content = "page-relevancy-tags-module--content--ae5c7";
export var iconWrapper = "page-relevancy-tags-module--iconWrapper--2890c";
export var next = "page-relevancy-tags-module--next--5b56e";
export var pageTags = "page-relevancy-tags-module--pageTags--01717";
export var prev = "page-relevancy-tags-module--prev--5088f";
export var tag = "page-relevancy-tags-module--tag--17bb7";
export var wrapper = "page-relevancy-tags-module--wrapper--9e3ee";